import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ResetPasswordPage() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { resetPasswordConfirm } = useAuth(); // Action to update password
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token'); // Extracts token from URL

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (!token) { setError('Jeton de réinitialisation invalide ou manquant.'); return; }
    if (password !== confirmPassword) { setError('Les mots de passe ne correspondent pas.'); return; }
    if (password.length < 8) { setError('Le mot de passe doit contenir au moins 8 caractères.'); return; }
    
    setLoading(true);
    setError('');
    
    try {
      // Calls your backend: POST /api/auth/reset-password { token, newPassword }
      await resetPasswordConfirm(token, password);
      alert('Mot de passe mis à jour avec succès !');
      navigate('/login');
    } catch (err) {
      setError('Lien expiré ou invalide. Veuillez refaire une demande.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ /* Same wrapper styles */ paddingTop: 'var(--nav-h, 64px)', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F5F0E8' }}>
      <div style={{ /* Same box styles */ background: '#fff', border: '1px solid rgba(140,122,106,0.2)', borderRadius: 4, padding: 48, maxWidth: 400, width: '100%', margin: '0 20px' }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 6 }}>Nouveau mot de passe</h1>
        
        <div style={{ marginBottom: 18 }}>
          <label style={{ display: 'block', fontFamily: 'Space Mono, monospace', fontSize: 10, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#8C7A6A', marginBottom: 6 }}>Nouveau mot de passe</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)}
            style={{ width: '100%', padding: '12px 16px', border: '1px solid rgba(140,122,106,0.3)', borderRadius: 2, outline: 'none' }} />
        </div>
        
        <div style={{ marginBottom: 24 }}>
          <label style={{ display: 'block', fontFamily: 'Space Mono, monospace', fontSize: 10, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#8C7A6A', marginBottom: 6 }}>Confirmer le mot de passe</label>
          <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)}
            style={{ width: '100%', padding: '12px 16px', border: '1px solid rgba(140,122,106,0.3)', borderRadius: 2, outline: 'none' }} />
        </div>

        {error && <p style={{ color: 'var(--radar-orange)', fontSize: 13, marginBottom: 16 }}>{error}</p>}

        <button onClick={handleSubmit} disabled={loading} style={{
          width: '100%', padding: '13px', background: 'var(--radar-deep)', color: '#fff', border: 'none',
          borderRadius: 2, fontFamily: 'Space Mono, monospace', fontSize: 13, cursor: loading ? 'not-allowed' : 'pointer', textTransform: 'uppercase'
        }}>
          {loading ? 'Enregistrement...' : 'Mettre à jour'}
        </button>
      </div>
    </div>
  );
}